export default __webpack_public_path__ + "client01.jpg";